import { render, staticRenderFns } from "./H5PackageOrder.vue?vue&type=template&id=82fa5ce8&scoped=true"
import script from "./H5PackageOrder.vue?vue&type=script&lang=js"
export * from "./H5PackageOrder.vue?vue&type=script&lang=js"
import style0 from "./H5PackageOrder.vue?vue&type=style&index=0&id=82fa5ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fa5ce8",
  null
  
)

export default component.exports